module.exports = __webpack_public_path__ + "static/media/arrow-up.5cf268d4.svg";